export const typeQuantityMap = Object.freeze({
  'quantity-length': {
    type: 'quantity',
    quantity: 'length',
  },
  'quantity-volume': {
    type: 'quantity',
    quantity: 'volume',
  },
  lumpSum: { type: 'lumpSum', quantity: 'length' },
  dayRate: { type: 'dayRate', quantity: 'length' },
  'quantity-itemCount': {
    type: 'quantity',
    quantity: 'itemCount',
  },
});

export const PriceBookType = Object.freeze({
  Name: 'name',
  CostCodesId: 'costCodesId',
  Vendor: 'vendor',
  Price: 'price',
  Currency: 'currency',
  PriceType: 'priceType',
  CompanyId: 'companyId',
  PriceBookItemId: 'priceBookItemId',
  PriceBookId: 'priceBookId',
});
